import Bind from 'bind.js';

export default class FAQ {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addContent();
  }

  addContent() {
    let template = `
      <div class="faqs-container">
        <h2>FAQs</h2>
        <div class="faqs-content"></div>
      </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        faqs: this.data.get('faqs').toJS()
      },
      {
        faqs: {
          dom: '.faqs-content',
          transform: function(faq) {
            return `<div class="faq">
              <div class="question">${faq.question}</div>
              <div class="answer">${faq.answer}</div>
            </div>`;
          },
        },
      }
    );

    this.scrollToItem();
  }

  reRender(data) {
    this.data = data;
    this.editor.faqs = data.get('faqs').toJS();
  }

  scrollToItem() {
      let queryStrings = window.location.search.substr(1).split("&");
      let openItem = -1;
      queryStrings.forEach((queryString) => {
          if (queryString.indexOf("faq=") === 0) {
              openItem = Number(queryString.substr(4));
          }
      });
      if (openItem !== -1) {
          let faqs = document.getElementsByClassName('faq');
          window.scrollTo(0, faqs[openItem].offsetTop);
      }
  }
}



// WEBPACK FOOTER //
// ./src/renderers/FAQ.js